import React from 'react';
import PropTypes from 'prop-types';

const CollapsibleDrawer = ({
  placement = 'left',
  isOpen = false,
  onToggle,
  children,
  width = '300px',
  height = '100%',
  className = '',
}) => {
  const handleToggle = () => {
    if (onToggle) {
      onToggle(!isOpen);
    }
  };

  const getDrawerStyles = () => {
    const viewportHeight = '100vh';
    const baseStyles = {
      position: 'fixed',
      backgroundColor: '#fff',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      transition: 'transform 0.3s ease-in-out',
      zIndex: 9999,
      overflowY: 'auto',
      overflowX: 'hidden',
      WebkitOverflowScrolling: 'touch',
    };

    switch (placement) {
      case 'left':
        return {
          ...baseStyles,
          top: 0,
          left: 0,
          width,
          height: height === '100%' ? viewportHeight : height,
          maxHeight: viewportHeight,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          transform: isOpen ? 'translateX(0)' : `translateX(-${width})`,
        };
      case 'right':
        return {
          ...baseStyles,
          top: 0,
          right: 0,
          width,
          height: height === '100%' ? viewportHeight : height,
          maxHeight: viewportHeight,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          transform: isOpen ? 'translateX(0)' : `translateX(${width})`,
        };
      case 'top':
        return {
          ...baseStyles,
          top: 0,
          left: 0,
          width: '100%',
          height,
          maxHeight: viewportHeight,
          transform: isOpen ? 'translateY(0)' : `translateY(-${height})`,
        };
      case 'bottom':
        return {
          ...baseStyles,
          bottom: 0,
          left: 0,
          width: '100%',
          height,
          maxHeight: viewportHeight,
          transform: isOpen ? 'translateY(0)' : `translateY(${height})`,
        };
      default:
        return baseStyles;
    }
  };

  return (
    <>
      <div
        className={`collapsible-drawer ${className}`}
        style={getDrawerStyles()}
      >
        {children}
      </div>

      {isOpen && (
        <div
          className="drawer-overlay"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.3)',
            zIndex: 9998,
          }}
          onClick={handleToggle}
          onKeyDown={(e) => e.key === 'Escape' && handleToggle()}
          role="button"
          tabIndex={0}
        />
      )}
    </>
  );
};

CollapsibleDrawer.propTypes = {
  placement: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  children: PropTypes.node.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
};

CollapsibleDrawer.defaultProps = {
  placement: 'left',
  isOpen: false,
  onToggle: null,
  width: '300px',
  height: '100%',
  className: '',
};

export default CollapsibleDrawer;
